import React, { useEffect, useState, useContext, useCallback } from "react";
import loaderContext from "../../../../../../context/loader/loaderContext";
import HelpVideoDisplay from "../videoDisplay";
import VideosDisplayCards from "../videoDisplayCards";
import { listVideos } from "../../../services/azureBlobService";
import { useConfig } from "../../../../../../context/config/configContext";

const HelpVideosStore = () => {
  const { updateLoaderStatus } = useContext(loaderContext);
  const [selectedVideoLink, setSelectedVideoLink] = useState("");
  const [videos, setVideos] = useState([]);
  const [videosOriginal, setVideosOriginal] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { config } = useConfig();
  const sasToken = config.REACT_APP_AZURE_SAS_TOKEN;

  useEffect(() => {
    if (!sasToken) return;
    const fetchVideos = async () => {
      setIsLoading(true);
      updateLoaderStatus(true);
      try {
        const videoData = await listVideos(sasToken);
        if (!selectedVideoLink && videoData?.length > 0) {
          setSelectedVideoLink(videoData[0].url);
        }
        setVideos(videoData || []);
        setVideosOriginal(videoData || []);
      } catch (err) {
        console.error("Error fetching videos:", err);
      } finally {
        updateLoaderStatus(false);
        setIsLoading(false);
      }
    };

    fetchVideos();
  }, [sasToken]);

  useEffect(() => {
    if (searchValue) {
      const lowercasedVal = searchValue.toLowerCase();
      const filteredVideos = videosOriginal?.filter((item) =>
        item.name.toLowerCase().includes(lowercasedVal)
      );
      if (filteredVideos?.length > 0) {
        setSelectedVideoLink(filteredVideos[0].url);
      } else {
        setSelectedVideoLink("");
      }
      setVideos(filteredVideos || []);
    } else {
      if (videosOriginal?.length > 0) {
        setSelectedVideoLink(videosOriginal[0].url);
      }
      setVideos(videosOriginal || []);
    }
  }, [searchValue]);

  const handleVideoSelect = useCallback((url) => {
    setSelectedVideoLink(url);
  }, []);

  const onInputSearchHelpVideo = (val) => {
    setSearchValue(val);
  };

  return (
    <div className="dash-section">
      <div className="skills-tabs help-section">
        <HelpVideoDisplay selectedVideoLink={selectedVideoLink} />

        <VideosDisplayCards
          helpVideos={videos}
          onVideoSelect={handleVideoSelect}
          selectedVideoLink={selectedVideoLink}
          onInputSearchHelpVideo={onInputSearchHelpVideo}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default HelpVideosStore;
